module.exports = __webpack_public_path__ + "img/Skill.50560793.svg";